import * as React from "react";
import { useCopy } from "../../containers";
import { useThemedAsset } from "../../hooks/use-themed-asset";

interface IEmailProps {
  copy: {
    message: string;
    linkText: string;
  };
}
const Email: React.FC<IEmailProps> = ({ copy: { message, linkText } }) => {
  const image = useThemedAsset("/images/photo.jpg");

  return (
    <div
      style={{
        width: "700px",
        margin: "0 auto",
        fontSize: "18px",
        fontFamily: "serif",
        background: "#fff",
        color: "#333"
      }}
    >
      <img src={image} alt="" width={700} height={465} />
      <div
        style={{
          width: "700px"
        }}
        dangerouslySetInnerHTML={{
          __html: message
        }}
      />

      <p
        style={{
          textAlign: "left"
        }}
      >
        <a
          href="https://pirate-shop.dzoni.dev"
          style={{
            display: "inline-block",
            padding: "5px 10px",
            color: "purple",
            textDecoration: "none"
          }}
        >
          {linkText}
        </a>
      </p>
    </div>
  );
};

export const EmailContainer: React.FC = () => {
  const copy = useCopy("email");

  return <Email copy={copy} />;
};
